























































































































import Vue from "vue";
import Color from "color";
import ColourWheel from "./ColourWheel.vue";

export default Vue.extend({
  name: "ColourConverter",
  components: {
    ColourWheel,
  },
  props: { BaseHue: Number, ComplementaryHue: Number },
  data() {
    return {
      CurrentColour: Color.rgb(100, 50, 50),
      CurrentControl: undefined,
    };
  },
  computed: {
    CardStyle() {
      return {
        backgroundColor: `hsl(${this.BaseHue}, 90%, 99%)`,
      };
    },
    SliderColour() {
      return `hsl(${this.ComplementaryHue}, 70%, 70%)`;
    },
    TrackColour() {
      return `hsl(${this.ComplementaryHue}, 70%, 85%)`;
    },
    HeadingStyle() {
      return {
        textDecoration: "underline",
        textDecorationColor: `hsl(${this.ComplementaryHue},70%,70%)`,
      };
    },
    CurrentRGB(): string {
      return `rgb(${this.R}, ${this.G}, ${this.B})`;
    },
    RGB(): Color {
      return this.CurrentColour.rgb();
    },
    HSL(): Color {
      return this.CurrentColour.hsl();
    },
    H(): number {
      return this.CurrentColour.hue();
    },
    S(): number {
      return this.CurrentColour.saturationl();
    },
    L(): number {
      return this.CurrentColour.lightness();
    },
    R(): number {
      return this.CurrentColour.red();
    },
    G(): number {
      return this.CurrentColour.green();
    },
    B(): number {
      return this.CurrentColour.blue();
    },
    Hex: {
      get: function(): string {
        return this.CurrentColour.hex();
      },
      set: function(newValue: string) {
        const isCorrectLength = newValue.length === 7;
        const startsWithHash = newValue[0] === "#";
        const isHex = newValue
          .slice(1, 7)
          .split("")
          .every((letter) =>
            [
              "0",
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "a",
              "b",
              "c",
              "d",
              "e",
              "f",
            ].includes(letter.toLowerCase())
          );
        if (!isCorrectLength || !startsWithHash || !isHex) return;
        this.CurrentColour = Color(newValue.toLowerCase()).rgb();
      },
    },
    IsPortrait: function() {
      return window.innerHeight > window.innerWidth;
    },
  },
  watch: {
    BaseHue: {
      handler(val) {
        const h = val;
        const s = 80;
        const l = 70;

        this.CurrentColour = Color.hsl(h, s, l).rgb();
      },
    },
  },
  created() {
    this.CurrentColour = Color.rgb(200, 50, 50);
  },
  updated() {},
  mounted() {},
  methods: {
    ClickedWheel(val: [number, number, number]) {
      const [h, s, l] = val;
      let col = Color.hsl(h, s, l).rgb();
      this.CurrentColour = col;
    },
    SetHue(val: number) {
      if (this.CurrentControl !== "hue") return;
      let h = val;
      this.CurrentColour = Color.hsl(h, this.S, this.L).rgb();
    },
    SetSaturation(val: number) {
      if (this.CurrentControl !== "saturation") return;
      let s = val;
      this.CurrentColour = Color.hsl(this.H, s, this.L).rgb();
    },
    SetLight(val: number) {
      if (this.CurrentControl !== "light") return;
      let l = val;
      this.CurrentColour = Color.hsl(this.H, this.S, l).rgb();
    },
    SetRed(val: number) {
      if (this.CurrentControl !== "red") return;
      let r = val;
      this.CurrentColour = Color.rgb(r, this.G, this.B);
    },
    SetGreen(val: number) {
      if (this.CurrentControl !== "green") return;
      let g = val;
      this.CurrentColour = Color.rgb(this.R, g, this.B);
    },
    SetBlue(val: number) {
      if (this.CurrentControl !== "blue") return;
      let b = val;
      this.CurrentColour = Color.rgb(this.R, this.G, b);
    },
  },
});
